import { render, staticRenderFns } from "./inviteFriends.vue?vue&type=template&id=dd824f36&scoped=true"
import script from "./inviteFriends.vue?vue&type=script&lang=js"
export * from "./inviteFriends.vue?vue&type=script&lang=js"
import style0 from "./inviteFriends.vue?vue&type=style&index=0&id=dd824f36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd824f36",
  null
  
)

export default component.exports